import React from 'react'
import { Form, Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Actions from '../../../../actions'
import { event, eventTypes } from '../../../../consts/eventConsts'
import MaterialInput from '../../../common/MaterialInput'
import Page from '../../../common/Page'
import PageCard from '../../../common/PageCard'

import './LoginWithOneTimeCode.css'

const LoginWithOneTimeCode = () => {
  const [form] = Form.useForm()
  const phoneNumberRegex = /^\d{10}$/

  const dispatch = useDispatch()

  const { isLoginLoading, oneTimeLoginError } = useSelector(state => state.auth)

  const verifyPhoneNumber = data => {
    dispatch(
      Actions.createAction(Actions.LOGIN_PHONE_NUMBER_REQUESTED, {
        phoneNumber: `+${data.phoneNumber.code}${data.phoneNumber.phone}`,
      })
    )
  }

  const validatePhoneNumber = (rule, value, callback) => {
    // const trimmedValue = value.phone.replaceAll(' ', '')
    const isValidPhoneNumber = phoneNumberRegex.test(value.phone)
    if (!isValidPhoneNumber) {
      callback(
        $t('pages.getStarted.signupForm.errors.pleaseInputValidPhoneNumber')
      )
    } else {
      callback()
    }
  }

  return (
    <PageCard className="login-with-one-time-code-page-card login-page-card">
      <Page
        hideAlertBanner={true}
        className="login-with-one-time-code-container login-page"
        title={$t('pages.getStarted.loginWithOneTimeCode.whatSYourPhoneNumber')}
        subtitle={$t(
          'pages.getStarted.loginWithOneTimeCode.weLlTextYouAOneTimeCode'
        )}
      >
        <Form
          className="login-otc-container"
          onFinish={verifyPhoneNumber}
          onFinishFailed={error => {
            dispatch(
              Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
                type: eventTypes.formEvent,
                eventName: event.formEvent.invalid,
                element: 'Sign-in',
                data: error.values,
                error: error,
              })
            )
          }}
          name="basic"
          initialValues={{
            phoneNumber: {
              code: 1,
              phone: '',
              short: 'US',
            },
          }}
          form={form}
        >
          <div className="one-time-login-form-item-input-container">
            <Form.Item
              className="one-time-login-form-item-input"
              name={'phoneNumber'}
              type="text"
              rules={[{ validator: validatePhoneNumber }]}
            >
              <MaterialInput
                className="one-time-login-phonenumber"
                label={$t('pages.getStarted.signupForm.phoneNumber')}
                type="phone"
              />
            </Form.Item>
            <div className="error-message">{oneTimeLoginError}</div>
          </div>
          <Form.Item className="one-time-login-form-item">
            <Button
              className="one-time-login-next-button"
              htmlType="submit"
              type="primary"
              loading={isLoginLoading}
            >
              {$t('pages.getStarted.signupForm.next')}
            </Button>
          </Form.Item>
        </Form>
      </Page>
    </PageCard>
  )
}

export default LoginWithOneTimeCode
